import { render, staticRenderFns } from "./AirList.vue?vue&type=template&id=2c63a260&scoped=true"
import script from "./AirList.vue?vue&type=script&lang=js"
export * from "./AirList.vue?vue&type=script&lang=js"
import style0 from "./AirList.vue?vue&type=style&index=0&id=2c63a260&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c63a260",
  null
  
)

export default component.exports